<template>
  <!-- D: 모달은 .l-wrap 바깥에 넣어주세요. -->
  <!-- D: 퍼블에서는 hidden 클래스넣지만 개발에서는 동적으로 불러와야할 듯합니다 -->
  <div v-if="onBoardPopVisible" id="orderOnboard" class="modal" data-popup>
    <div class="dialog type-onboard">
      <header class="dialog-header">
        <h2 class="sr-only">메인 온보드</h2>
        <button type="button" class="dialog-close" data-popup-close>
          <span class="c-icon icon-medium-x2"></span>
          <span class="sr-only">팝업 닫기</span>
        </button>
      </header>

      <div class="dialog-content">
        <div class="dialog-content-inner">
          <div class="onboard-wrap">
            <div class="swiper-wrap">
              <div class="swiper onboard-swiper" data-swiper-id="swiperOnboard">
                <div class="swiper-wrapper">
                  <!-- D: PC, MO 내용 다름 예외처리 필요 -->
                  <!-- PC -->
                  <template v-if="!isMobile">
                    <div class="swiper-slide">
                      <div class="onboard-item">
                        <div class="head">
                          <h3 class="title">제품 필터링 기능 제공</h3>
                          <p class="text">
                            시장, 용도, 제품군별 원하는 제품을 빠르게 찾을 수
                            있어요
                          </p>
                        </div>
                        <div class="onboard-img">
                          <img
                            src="@/assets/images/etc/img_onboard_pr_01.jpg"
                            alt=""
                          />
                        </div>
                      </div>
                    </div>
                    <div class="swiper-slide">
                      <div class="onboard-item">
                        <div class="head">
                          <h3 class="title">바로주문 기능 제공</h3>
                          <p class="text">
                            클릭 시 우측 주문서 영역에서 주문 제품을 확인할 수
                            있어요
                          </p>
                        </div>
                        <div class="onboard-img">
                          <img
                            src="@/assets/images/etc/img_onboard_pr_02.jpg"
                            alt=""
                          />
                        </div>
                      </div>
                    </div>
                    <div class="swiper-slide">
                      <div class="onboard-item">
                        <div class="head">
                          <h3 class="title">쉽고 빠른 주문 프로세스 제공</h3>
                          <p class="text">
                            제품 찾고 주문까지 한 화면에서 할 수 있어요
                          </p>
                        </div>
                        <div class="onboard-img">
                          <img
                            src="@/assets/images/etc/img_onboard_pr_03.jpg"
                            alt=""
                          />
                        </div>
                      </div>
                    </div>
                    <div class="swiper-slide">
                      <div class="onboard-item">
                        <div class="head">
                          <h3 class="title">사용자 매뉴얼 제공</h3>
                          <p class="text">
                            클릭하면 현재 보고 있는 화면의 자세한 설명을 볼 수
                            있어요
                          </p>
                        </div>
                        <div class="onboard-img">
                          <img
                            src="@/assets/images/etc/img_onboard_pr_04.jpg"
                            alt=""
                          />
                        </div>
                      </div>
                    </div>
                  </template>
                  <!-- // PC -->
                  <!-- MO -->
                  <template v-else>
                    <div class="swiper-slide">
                      <div class="onboard-item">
                        <div class="head">
                          <h3 class="title">제품 필터링 기능 제공</h3>
                          <p class="text">
                            시장, 용도, 제품군별 <br />
                            원하는 제품을 빠르게 찾을 수 있어요
                          </p>
                        </div>
                        <div class="onboard-img">
                          <img
                            src="@/assets/images/etc/img_onboard_pr_mo_01.jpg"
                            alt=""
                          />
                        </div>
                      </div>
                    </div>
                    <div class="swiper-slide">
                      <div class="onboard-item">
                        <div class="head">
                          <h3 class="title">바로주문 기능 제공</h3>
                          <p class="text">
                            터치 시 주문서 화면에서 <br />
                            주문 제품을 확인할 수 있어요
                          </p>
                        </div>
                        <div class="onboard-img">
                          <img
                            src="@/assets/images/etc/img_onboard_pr_mo_02.jpg"
                            alt=""
                          />
                        </div>
                      </div>
                    </div>
                    <div class="swiper-slide">
                      <div class="onboard-item">
                        <div class="head">
                          <h3 class="title">쉬운 주문서 작성</h3>
                          <p class="text">
                            배송 정보~주문 제품(수량, 금액)까지 <br />
                            한 화면에서 볼 수 있어요
                          </p>
                        </div>
                        <div class="onboard-img">
                          <img
                            src="@/assets/images/etc/img_onboard_pr_mo_03.jpg"
                            alt=""
                          />
                        </div>
                      </div>
                    </div>
                    <div class="swiper-slide">
                      <div class="onboard-item">
                        <div class="head">
                          <h3 class="title">사용자 매뉴얼 제공</h3>
                          <p class="text">
                            현재 보고 있는 화면의 <br />
                            자세한 설명을 볼 수 있어요
                          </p>
                        </div>
                        <div class="onboard-img">
                          <img
                            src="@/assets/images/etc/img_onboard_pr_mo_04.jpg"
                            alt=""
                          />
                        </div>
                      </div>
                    </div>
                  </template>
                  <!-- // MO -->
                </div>
              </div>
              <div
                class="c-swiper-indicator"
                data-swiper-indicator-id="swiperOnboard"
              ></div>
            </div>
          </div>
        </div>
      </div>
      <div class="dialog-footer">
        <div class="c-checkbox" @click="btnCmd('todayHide')">
          <input type="checkbox" id="chkDay" name="chkDay" />
          <label for="chkDay">오늘 하루 보지 않기</label>
        </div>
        <div class="c-btn-area">
          <button type="button" class="c-button type-primary" data-next-slide>
            <span>{{ nextSlideText }}</span>
          </button>
        </div>
      </div>
    </div>
    <!-- D: dimmed -->
    <div class="dimmed"></div>
  </div>
</template>
<script setup>
import { onMounted, ref, defineEmits } from "vue";
import * as cmUtil from "@/utils/cmUtil.js";
const { isMobile } = cmUtil.useDeviceType();

import Swiper, { Pagination } from "swiper";
import "swiper/css";
import "swiper/css/pagination";

const emits = defineEmits(["close"]);
const onBoardPopVisible = ref(true);
const nextSlideText = ref("계속하기");

/**********************
 * 스와이퍼 호출
 *********************/
function initSwiper() {
  const nextSlideBtn = document.querySelector("[data-next-slide]");
  // onboard swipe
  const swiperOnboard = new Swiper('[data-swiper-id="swiperOnboard"]', {
    modules: [Pagination],
    speed: 400,
    slidesPerView: 1,
    spaceBetween: 20,
    pagination: {
      clickable: true,
      el: '[data-swiper-indicator-id="swiperOnboard"]',
      type: "bullets",
    },
  });

  swiperOnboard.on("slideChange", function () {
    // 마지막 페이지
    if (swiperOnboard.slides.length - 1 === swiperOnboard.realIndex) {
      nextSlideText.value = "제품 주문 시작하기";
    } else {
      nextSlideText.value = "계속하기";
    }
  });

  nextSlideBtn.addEventListener("click", () => {
    // 마지막
    if (swiperOnboard.isEnd) {
      onBoardPopVisible.value = false;
      return;
    }
    // 마지막 페이지
    if (swiperOnboard.slides.length - 2 === swiperOnboard.realIndex) {
      nextSlideText.value = "제품 주문 시작하기";
    } else {
      nextSlideText.value = "계속하기";
    }
    swiperOnboard.slideNext();
  });
}

/**********************
 * Mounted
 *********************/
onMounted(() => {
  initSwiper();
});

/**********************
 * 버튼 클릭 모음
 *********************/
async function btnCmd(cmd = "", parms = {}) {
  if (cmd === "todayHide") {
    cmUtil.setLocalStorage(
      "gv.orderOnBoardLayer.hiddenDate",
      cmUtil.getToday()
    );
    emits("close");
  } else {
    alert(`[개발확인] btnCmd() cmd [${cmd}] 를 확인해주세요` + parms);
    return false;
  }
}
</script>
